import { useBrand } from '../context/BrandContext';
import FastestFormCRMPipelineView from './fastestform/CRMPipelineView';
import AbleCRMPipelineView from './able/CRMPipelineView';

export default function CRMPipelineView() {
  const { brand } = useBrand();
  return brand === 'able' ? <AbleCRMPipelineView /> : <FastestFormCRMPipelineView />;
}
